import { Icon, IconButton, Tooltip } from "@mui/material";
import { draftColors } from "modules/proposals/draft/draftDesignTokens";

type WorksheetIconButtonProps = {
  icon: string;
  title: string;
  ariaLabel: string;
  size?: number;
  onClick?: () => void;
  disabled?: boolean;
};

export default function WorksheetIconButton({
  icon,
  title,
  ariaLabel,
  size = 16,
  onClick,
  disabled,
}: WorksheetIconButtonProps) {
  return (
    <Tooltip title={title}>
      <IconButton
        size="small"
        aria-label={ariaLabel}
        disabled={disabled}
        onClick={onClick}
        sx={{
          width: 24,
          height: 24,
          p: 0,
          flexShrink: 0,
          border: `1px solid ${draftColors.border}`,
          borderRadius: "6px",
          color: draftColors.textAction,
          backgroundColor: draftColors.surface,
        }}
      >
        <Icon sx={{ fontSize: size }}>{icon}</Icon>
      </IconButton>
    </Tooltip>
  );
}
